
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useEffect, useRef, useState } from "react";
import Page from "@/src/components/Page";
import AuthShell from "@/src/layouts/AuthShell";
import AuthContent from "@/src/components/AuthContent";
import AuthCard from "@/src/components/AuthCard";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Checkbox,
  CloseButton,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useColorMode,
  useToast,
  Text
} from "@chakra-ui/react";
import { ExternalLinkIcon, Icon } from "@chakra-ui/icons";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { useAuth } from "@/src/contexts/AuthContext";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { validateEmail,validateGeneralEmail } from "@/src/utils/validate-functions";
import CustomLink from "@/src/components/CustomLink";
import useTranslation from "next-translate/useTranslation";

function Auth({query}) {
  const { t } = useTranslation();
  const auth = useAuth();
  const router = useRouter();
  const [type, setType] = useState(query?.type);
  const [isLogin, setIsLogin] = React.useState(true);
  const [isRegister, setIsRegister] = React.useState(false);
  const [tabIndex, setTabIndex] = React.useState(isLogin ? 0 : 1);
  const allowed = ["manager", "collaborator"];
  const toast = useToast();
  const [show, setShow] = React.useState(false);
  const [successRegister, setSuccessRegister] = React.useState(null);
  const [errorLogin, setErrorLogin] = React.useState(null);
  const handleShowPassword = () => setShow(!show);
  const [loading, setLoading] = React.useState(false);
  const { colorMode } = useColorMode();
  const { redirect_url } = router.query;

  const {
    handleSubmit: handleSubmitLogin,
    register: registerLogin,
    formState: { errors: errorsLogin },
  } = useForm({ mode: "all" });
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ mode: "all" });

  useEffect(() => {
    const router_type = router?.query?.type;
    if (router_type !== "undefined") {
      setType(router_type);
    }
    if (!allowed.includes(type)) {
      router.replace("/account/choose");
    }
  }, [type, router]);

  const onLogin = async (data) => {
    setLoading(true);
    const resp = await auth.login(data);
    if (resp?.id) {
      setLoading(false);
      toast({
        position: "top-right",
        title: t("notification:toast.login.success.title"),
        description:
          auth?.authSuccess || t("notification:toast.login.success.message"),
        status: "success",
        duration: 8000,
        isClosable: true,
      });
      if(redirect_url){
        window.location.href=redirect_url
      }else{
        if(resp?.role=='administrator'){
          await router.push("/app/admin");
        }else{
          await router.push("/app/dashboard");
        }
      }
     
    } else {
      setLoading(false);
      setErrorLogin(resp?.data?.detail || auth?.authError?.detail);
    }
    setLoading(false);
  };

  const onRegister = async (data) => {
    if (type === "manager") {
      setLoading(true);
      let resp = await auth.register_manager(data);
      resp = await resp?.json();
      if (resp?.data?.user) {
        setLoading(false);
        setSuccessRegister(t("notification:toast.register.success.message"));
      } else {
        setLoading(false);
        toast({
          position: "top-right",
          title: t("notification:toast.bad_request.title"),
          description:
            resp?.data?.email ||
            resp?.data?.password ||
            resp?.data?.terms_consent ||
            resp?.data?.account_type,
          status: "error",
          duration: 8000,
          isClosable: true,
        });
      }
      setLoading(false);
    }
    if (type === "collaborator") {
      setLoading(true);
      let resp = await auth.register_collaborator(data);
      resp = await resp?.json();
      if (resp?.data?.user) {
        setLoading(false);
        setSuccessRegister(resp?.data?.detail);
      } else {
        setLoading(false);
        toast({
          position: "top-right",
          title: t("notification:toast.bad_request.title"),
          description:
            resp?.data?.email ||
            resp?.data?.password ||
            resp?.data?.terms_consent ||
            resp?.data?.account_type,
          status: "error",
          duration: 8000,
          isClosable: true,
        });
      }
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <AuthContent
        title={t("account:register.page.title")}
        sub_title={t("account:register.page.sub_title")}
        desc={t("account:register.page.description")}
      >
        <AuthCard
          title={t("account:register.card.welcome_text")}
          title_suffix={"Watchman"}
          isRegister={isRegister}
          isLogin={isLogin}
        >
          <Tabs variant={"unstyled"} isFitted width={"full"}>
            <TabList align={"start"} p={0}>
            <Tab
                px={0}
                justifyContent={"flex-start"}
                fontWeight={"500"}
                fontSize={"32px"}
                lineHeight={"48px"}
                color={colorMode === "light" ? "inherit" : "white"}
                _selected={{
                  color: "#00B295",
                  borderRight: "1px solid #F3D4D4",
                  borderRightHeight: "50px",
                }}
              >
                {t("account:register.card.title")}
              </Tab>
            <Tab
                px={0}
                justifyContent={"flex-end"}
                fontWeight={"500"}
                fontSize={"32px"}
                lineHeight={"48px"}
                color={colorMode === "light" ? "inherit" : "white"}
                _selected={{
                  color: "#00B295",
                  borderLeft: "1px solid #F3D4D4",
                  borderLeftHeight: "50px",
                }}
              >
                {t("account:login.card.title")}
                
              </Tab>
              
              
            </TabList>

            <TabPanels>
              
              <TabPanel px={0}>
                <Stack
                  as={"form"}
                  spacing={0}
                  errors={errors}
                  {...register}
                  onSubmit={handleSubmit((data) => onRegister(data))}
                  mt={"22px"}
                >
                  <FormControl
                    isRequired
                    isInvalid={errors?.email && errors?.email.message}
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                      fontSize={"16px"}
                      fontWeight={"400"}
                      lineHeight={"24px"}
                    >
                      {t("account:login.card.email.name")}
                    </FormLabel>
                    <Input
                      borderColor={
                        colorMode === "light" ? "inherit" : "brand.700"
                      }
                      bg={colorMode === "light" ? "white" : "transparent"}
                      color={colorMode === 'light' ? 'inherit' : 'white'}
                      _placeholder={{
                        color: colorMode === "light" ? "inherit" : "gray.200",
                      }}
                      _hover={{
                        bgColor:
                          colorMode === "light" ? "white" : "transparent",
                      }}
                      id="email"
                      name={"email"}
                      w={"full"}
                      variant={"outline"}
                      autoComplete={"username"}
                      type={"text"}
                      placeholder={t("account:register.card.email.placeholder")}
                      {...register("email", {
                        required: t("common:validation.email_required"),
                        validate: (email) => {
                          return validateGeneralEmail(email, t);
                        },
                      })}
                    />
                    {errors?.email ? (
                      <FormErrorMessage mb={2}>
                        {errors?.email && errors?.email.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={2}>
                        {t("account:register.card.email.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    isRequired
                    isInvalid={errors?.password && errors?.password.message}
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:register.card.password.name")}
                    </FormLabel>
                    <InputGroup size="md">
                      <Input
                        borderColor={
                          colorMode === "light" ? "inherit" : "brand.700"
                        }
                        bg={colorMode === "light" ? "white" : "transparent"}
                        color={colorMode === 'light' ? 'inherit' : 'white'}
                        _placeholder={{
                          color: colorMode === "light" ? "inherit" : "gray.200",
                        }}
                        _hover={{
                          bgColor:
                            colorMode === "light" ? "white" : "transparent",
                        }}
                        id="password"
                        name={"password"}
                        w={"full"}
                        variant={"outline"}
                        type={show ? "text" : "password"}
                        placeholder={t(
                          "account:register.card.password.placeholder"
                        )}
                        autoComplete={"current-password"}
                        {...register("password", {
                          required: t("common:validation.password_required"),
                          minLength: {
                            value: 8,
                            message: t("common:validation.password_min_length"),
                          },
                        })}
                      />
                      <InputRightElement pt={2}>
                        <Icon
                          as={show ? IoEyeOutline : IoEyeOffOutline}
                          w={5}
                          h={5}
                          color={errors?.password ? "red.500" : "brand.500"}
                          onClick={handleShowPassword}
                        />
                      </InputRightElement>
                    </InputGroup>
                    {errors?.password ? (
                      <FormErrorMessage mb={2}>
                        {errors?.password && errors?.password.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={2}>
                        {t("account:register.card.password.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    isRequired
                    isInvalid={errors?.first_name && errors?.first_name.message}
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:register.card.first_name.name")}
                    </FormLabel>
                    <Input
                      borderColor={
                        colorMode === "light" ? "inherit" : "brand.700"
                      }
                      bg={colorMode === "light" ? "white" : "transparent"}
                      color={colorMode === 'light' ? 'inherit' : 'white'}
                      _placeholder={{
                        color: colorMode === "light" ? "inherit" : "gray.200",
                      }}
                      _hover={{
                        bgColor:
                          colorMode === "light" ? "white" : "transparent",
                      }}
                      id="first_name"
                      name={"first_name"}
                      w={"full"}
                      variant={"outline"}
                      type={"text"}
                      placeholder={t(
                        "account:register.card.first_name.placeholder"
                      )}
                      {...register("first_name", {
                        required: t("common:validation.first_name_required"),
                      })}
                    />
                    {errors?.first_name ? (
                      <FormErrorMessage mb={2}>
                        {errors?.first_name && errors?.first_name.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={2}>
                        {t("account:register.card.first_name.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    isRequired
                    isInvalid={errors?.last_name && errors?.last_name.message}
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:register.card.last_name.name")}
                    </FormLabel>
                    <Input
                      borderColor={
                        colorMode === "light" ? "inherit" : "brand.700"
                      }
                      bg={colorMode === "light" ? "white" : "transparent"}
                      color={colorMode === 'light' ? 'inherit' : 'white'}
                      _placeholder={{
                        color: colorMode === "light" ? "inherit" : "gray.200",
                      }}
                      _hover={{
                        bgColor:
                          colorMode === "light" ? "white" : "transparent",
                      }}
                      id="last_name"
                      name={"last_name"}
                      w={"full"}
                      variant={"outline"}
                      type={"text"}
                      placeholder={t(
                        "account:register.card.last_name.placeholder"
                      )}
                      {...register("last_name", {
                        required: t("common:validation.last_name_required"),
                      })}
                    />
                    {errors?.last_name ? (
                      <FormErrorMessage mb={2}>
                        {errors?.last_name && errors?.last_name.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={2}>
                        {t("account:register.card.last_name.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    py={4}
                    isRequired
                    isInvalid={
                      errors?.terms_consent && errors?.terms_consent.message
                    }
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:register.card.terms.name")}
                    </FormLabel>
                    <Checkbox
                      aria-label="Terms and Conditions"
                      isInvalid={!!errors?.terms_consent}
                      spacing="1rem"
                      id="terms_consent"
                      opacity={0.8}
                      bg={colorMode === 'light' ? "gray.50" : 'transparent'}
                      border={"3px solid"}
                      borderColor={
                        errors?.terms_consent ? "red.600" : "brand.300"
                      }
                      w={"full"}
                      px={2}
                      py={2}
                      fontSize={"2px"}
                      lineHeight={"24px"}
                      color={colorMode === 'light' ? "gray.500" : 'white'}
                      transition={"200ms ease-in-out"}
                      _hover={{ opacity: 1, borderColor: "brand.500" }}
                      _focus={{
                        opacity: 1,
                        borderColor: "brand.500",
                        boxShadow: "brand.500",
                      }}
                      rounded={"md"}
                      name="terms_consent"
                      type="checkbox"
                      placeholder={t("account:register.card.terms.placeholder")}
                      {...register("terms_consent", {
                        required: t("common:validation.terms_required"),
                      })}
                    >
                      {t("account:register.card.terms.text1")}{" "}
                      <CustomLink
                        to={"/docs/terms-conditions"}
                        isExternal
                        color={"brand.500"}
                      >
                        {t("account:register.card.terms.text2")}{" "}
                        <ExternalLinkIcon mx="2px" fontSize={"lg"} />
                      </CustomLink>
                    </Checkbox>
                    {errors?.last_name ? (
                      <FormErrorMessage mb={5}>
                        {errors?.terms_consent && errors?.terms_consent.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={5}>
                        {t("account:register.card.terms.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <Button
                    id="register"
                    isLoading={loading}
                    loadingText="Loading"
                    w={"full"}
                    type={"submit"}
                    fontWeight={500}
                    colorScheme={"brand"}
                  >
                    {t("account:register.card.button_text")}
                  </Button>
                </Stack>
                {successRegister && (
                  <Alert status="success" my={4}>
                    <AlertIcon />
                    <Box>
                      <AlertTitle>
                        {t("notification:alert.register.alert_created_title")}
                      </AlertTitle>
                      <AlertDescription>{successRegister}</AlertDescription>
                    </Box>
                    <CloseButton
                      alignSelf="flex-start"
                      position="relative"
                      right={-1}
                      top={-1}
                      onClick={() => setSuccessRegister(null)}
                    />
                  </Alert>
                )}
                <Stack py={10} w="full" >
              <Text fontSize="sm" color={colorMode === "light" ? "inherit" : "white"} textAlign={"left"} >
              {t("account:login.card.already_account")}  {"  "}
              <CustomLink
                  fontSize={"sm"}
                  to={redirect_url==null || redirect_url=='' || redirect_url=='undefined' ? "/account/login":redirect_url}
                  color={"brand.500"}
                >
                 {t("account:login.card.title")}
                </CustomLink>
              </Text>
                
            </Stack>
              </TabPanel>
              <TabPanel px={0}>
                <Stack
                  as={"form"}
                  spacing={0}
                  errors={errorsLogin}
                  {...registerLogin}
                  onSubmit={handleSubmitLogin((data) => onLogin(data))}
                >
                  <FormControl
                    isRequired
                    isInvalid={errorsLogin?.email && errorsLogin?.email.message}
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:login.card.email.name")}
                    </FormLabel>
                    <Input
                      borderColor={
                        colorMode === "light" ? "inherit" : "brand.700"
                      }
                      bg={colorMode === "light" ? "white" : "transparent"}
                      color={colorMode === 'light' ? 'inherit' : 'white'}
                      _placeholder={{
                        color: colorMode === "light" ? "inherit" : "gray.200",
                      }}
                      _hover={{
                        bgColor:
                          colorMode === "light" ? "white" : "transparent",
                      }}
                      id="email"
                      name={"email"}
                      w={"full"}
                      variant={"outline"}
                      autoComplete={"username"}
                      type={"text"}
                      placeholder={t("account:login.card.email.placeholder")}
                      {...registerLogin("email", {
                        required: t("common:validation.email_required"),
                        validate: (email) => {
                          return validateGeneralEmail(email, t);
                        },
                      })}
                    />
                    {errorsLogin?.email ? (
                      <FormErrorMessage mb={2}>
                        {errorsLogin?.email && errorsLogin?.email.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={2}>
                        {t("account:login.card.email.help")}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    isRequired
                    isInvalid={
                      errorsLogin?.password && errorsLogin?.password.message
                    }
                  >
                    <FormLabel
                      color={colorMode === "light" ? "inherit" : "white"}
                    >
                      {t("account:login.card.password.name")}
                    </FormLabel>
                    <InputGroup size="md">
                      <Input
                        borderColor={
                          colorMode === "light" ? "inherit" : "brand.700"
                        }
                        bg={colorMode === "light" ? "white" : "transparent"}
                        color={colorMode === 'light' ? 'inherit' : 'white'}
                        _placeholder={{
                          color: colorMode === "light" ? "inherit" : "gray.200",
                        }}
                        _hover={{
                          bgColor:
                            colorMode === "light" ? "white" : "transparent",
                        }}
                        id="password"
                        name={"password"}
                        w={"full"}
                        variant={"outline"}
                        autoComplete={"current-password"}
                        type={show ? "text" : "password"}
                        placeholder={t(
                          "account:login.card.password.placeholder"
                        )}
                        {...registerLogin("password", {
                          required: t("common:validation.password_required"),
                          minLength: {
                            value: 8,
                            message: t("common:validation.password_min_length"),
                          },
                        })}
                      />
                      <InputRightElement pt={2}>
                        <Icon
                          as={show ? IoEyeOutline : IoEyeOffOutline}
                          w={5}
                          h={5}
                          color={
                            errorsLogin?.password ? "red.500" : "brand.500"
                          }
                          onClick={handleShowPassword}
                        />
                      </InputRightElement>
                    </InputGroup>
                    {errorsLogin?.password ? (
                      <FormErrorMessage mb={1}>
                        {errorsLogin?.password && errorsLogin?.password.message}
                      </FormErrorMessage>
                    ) : (
                      <FormHelperText mb={1}>
                        {t("account:login.card.password.help")}
                      </FormHelperText>
                    )}
                    <Stack mb={5}>
                      <CustomLink
                        fontSize={"sm"}
                        alignSelf={"flex-end"}
                        to={"/account/reset-password"}
                        color={"brand.500"}
                      >
                        {t("common:forget_password")}
                      </CustomLink>
                    </Stack>
                  </FormControl>
                  <Button
                    id="login"
                    isLoading={loading}
                    loadingText={t("common:loading")}
                    w={"full"}
                    fontWeight={500}
                    type={"submit"}
                    colorScheme={"brand"}
                  >
                    {t("account:login.card.button_text")}
                  </Button>
                </Stack>
                {errorLogin && (
                  <Alert status="error" my={4}>
                    <AlertIcon />
                    <Box>
                      <AlertTitle color={colorMode === "light" ? "inherit" : "red.300"}>{t("common:error_login_title")}</AlertTitle>
                      <AlertDescription color={colorMode === "light" ? "inherit" : "white"}>{errorLogin}</AlertDescription>
                    </Box>
                    <CloseButton
                      alignSelf="flex-start"
                      position="relative"
                      right={-1}
                      top={-1}
                      onClick={() => setErrorLogin(null)}
                    />
                  </Alert>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </AuthCard>
      </AuthContent>
    </AuthShell>
  );
}

const RegisterPage = ({query}) => (
  <Page name="Login or Register" path="/account/auth">
    <Auth query={query} />
  </Page>
);

export default RegisterPage;

 async function _getServerSideProps(context) {
  const query = context.query; 
   return {
    props: { query }, 
  };
}

    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/account/auth',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  